var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9881 2.04492C6.55461 2.04492 2.14453 6.455 2.14453 11.8889C2.14453 17.3224 6.55429 21.7322 11.9878 21.7322C17.4217 21.7322 21.8318 17.3224 21.8318 11.8889C21.8318 6.455 17.4217 2.04525 11.9881 2.04525V2.04492ZM12.9725 16.8105H11.0038V10.9042H12.9725V16.8105ZM12.9725 8.93555H11.0038V6.96689H12.9725V8.93555Z",
    fill: "#4A88FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.616060ecd15798f77377289ebe36e894.svg";
export { ForwardRef as ReactComponent };